import classNames from "classnames";
import { useMemo, useRef, useState } from "react";
import styles from "./Swiper.module.scss";
import { useLayerSwiper } from "./useLayerSwiper";
import { Map as OlMap } from "ol";
import TileLayer from "ol/layer/Tile";
import TileSource from "ol/source/Tile";

type Props = {
  createdDates?: { startDate: string; endDate: string };
  olMap: OlMap;
  afterTileLayer: TileLayer<TileSource>;
};

const Swiper = ({ createdDates, olMap, afterTileLayer }: Props) => {
  // 핸들이 움직일 수 있는 너비를 나타내는 ref
  const rangeRef = useRef<HTMLDivElement>(null);

  const [swiperValue, setSwiperValue] = useState<number>(50);
  const [isMousedown, setMousedown] = useState(false);

  const pointerEventsStyle = useMemo(
    () => (isMousedown ? "auto" : "none"),
    [isMousedown]
  );

  const { rerender } = useLayerSwiper({ swiperValue, olMap, afterTileLayer });

  const onChange = (value: string) => {
    setSwiperValue(Number(value));
    rerender();
  };

  const onMouseMove = (e: React.MouseEvent) => {
    if (!isMousedown || !rangeRef.current) return;

    const rangeRect = rangeRef.current.getBoundingClientRect();
    const offsetX = e.clientX - rangeRect.left;
    const percent = Math.round((offsetX / rangeRect.width) * 100).toString();

    onChange(percent);
  };

  const onMouseUp = () => {
    setMousedown(false);
  };

  const onMouseDown = () => {
    setMousedown(true);
  };

  return (
    <>
      <div
        className={classNames(styles["swipe-container"])}
        onMouseMove={onMouseMove}
        onMouseUp={onMouseUp}
        style={{ pointerEvents: pointerEventsStyle }}
      >
        {/* 숨기는 핸들 */}
        <input
          type="range"
          readOnly
          value={swiperValue}
          className={styles["input-range"]}
        />
        <div className={styles["fake-container"]} ref={rangeRef} />

        {/* swiper 세로선 */}
        <div className={styles["swipe-bar-wrap"]} onMouseDown={onMouseDown}>
          <div
            className={styles["swipe-bar"]}
            style={{ left: `${swiperValue}%` }}
          />
          <div
            className={styles["swipe-handle"]}
            style={{ left: `${swiperValue}%` }}
          />
        </div>
        {/* 이전 타일 촬영날짜 */}
        <div
          className={classNames(styles["date__wrap"])}
          style={{ width: `${swiperValue}%` }}
        >
          <div className={styles["date"]}>
            {/* {createdDates && createdDates.startDate} */}
            Before
          </div>
        </div>

        {/* 이후 타일 촬영날짜 */}
        <div
          className={classNames(styles["date__wrap"])}
          style={{ width: `${100 - swiperValue}%` }}
        >
          <div className={styles["date"]}>
            After
            {/* {createdDates && createdDates.endDate} */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Swiper;
